import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="h-14 border-b border-border px-4 flex items-center justify-between bg-background sticky top-0 z-10">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-md bg-primary flex items-center justify-center">
              <ClipboardList className="h-4 w-4 text-primary-foreground" />
            </div>
            <span className="text-lg font-semibold text-foreground">
              Schedule Viewer
            </span>
          </Link>
          <span className="text-xs font-medium text-foreground-muted bg-background-subtle px-2 py-1 rounded">
            Read-only
          </span>
        </div>
      </header>

      {/* Main content (no sidebar -- simple read-only app) */}
      <main id="main-content" className="flex-1 min-w-0 p-6 bg-background-subtle">
        {children}
      </main>
    </div>
  );
}
